<template>
    <div class="work-role-item" :style="'background-image: url(' + cover_image.data.full_url + ')'" :class="isActive ? 'active': 'inactive'" v-on:click="clickRole()">
        <div class="role-info">
            <span class="mdi mdi-movie-open" v-if="role_type == 'synchron'"></span>
            <span class="mdi mdi-podcast" v-if="role_type == 'hoerbuch'"></span>
            <span class="mdi mdi-cart" v-if="role_type == 'werbung'"></span>
            <span class="mdi mdi-google-controller" v-if="role_type == 'videospiel'"></span>
            <span class="mdi mdi-book-open-page-variant" v-if="role_type == 'dialogbuch'"></span>
            <div class="content">
                <span class="name">{{ role_name }}</span>
                <span class="work">{{ role_work }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WorkRoleItem',
        props: [
            'isActive',
            'role_direction',
            'role_name',
            'role_studio',
            'role_type',
            'role_work',
            'role_url',
            'cover_image',
        ],
        methods: {
            clickRole: function() {
                if(this.$props.role_url != null) {
                    window.open(this.$props.role_url, '_blank');
                }
            }
        }
    };
</script>

<style scoped lang="less">
    .work-role-item {
        background: rgba(0,0,0,0.1);
        overflow: hidden;
        position: relative;
        padding-top: 100%;
        background-position: center;
        background-size: cover;
        border-radius: 7px;

        & .role-info {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            padding: 25px;
            opacity: 0;
            display: flex;
            color: #fff;
            justify-content: center;
            align-items: center;
            transition: 0.2s ease-in-out all;

            & .mdi {
                font-size: 200px;
                transform: rotate(-15deg);
                position: absolute;
                bottom: -50px;
                left: -50px;
                opacity: 0.3;
            }
            & .content {
                display: flex;
                flex-direction: column;
                text-align: center;

                & span {
                    display: inline-block;

                    &.name {
                        font-size: 22px;
                        margin-bottom: 10px;
                    }
                    &.work {
                        font-weight: 600;
                    }
                }
            }

            &:hover {
                background: rgba(0,0,0,0.4);
                backdrop-filter: blur(3px);
                opacity: 1;
                cursor: pointer;
            }
        }

        &.active {
            animation-name: go-to-active;
            animation-duration: 0.2s;
            animation-fill-mode: forwards;
        }
        &.inactive {
            animation-name: go-to-inactive;
            animation-duration: 0.2s;
            animation-fill-mode: forwards;
        }
    }

    @keyframes go-to-active {
        from {
            transform: scale(0);
            position: absolute;
        }
        to {
            transform: scale(1);
            position: relative;
        }
    }
    @keyframes go-to-inactive {
        from {
            transform: scale(1);
        }
        to {
            transform: scale(0);
            position: absolute;
        }
    }
</style>
